<template>
    <div>
        <!-- User Interface controls -->
        <b-row>
            <b-col md="12" class="my-1">
                <b-form-group label-cols="2" class="mb-0">
                    <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search" />
                        <b-input-group-append>
                            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <!-- Main table element -->
            <b-table show-empty empty-text="There are no files uploaded at this time" striped responsive stacked="md" 
                 :items="items" 
                 :fields="fields" 
                  :filter="filter" 
                  :sort-by.sync="sortBy"
                 @filtered="onFiltered">
            <template v-slot:cell(created_at)="row">
              {{ moment(row.item.created_at).format('MMM-DD-YYYY') }}
            </template>
            <template v-slot:cell(actions)="row" class="text-nowrap">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                    <div class="pb-2" v-for="file in row.item.evaluation_file.file_path" :key="file.id">
                      <b-button @click="downloadFile(row.item.user_id, file)" class="btn btn-warning btn-sm">
                        <span class="icon icon-eye"> View</span>
                      </b-button>
                    </div>
                    <b-button v-if="role == 'admin' || role == 'school'" @click="deleteFile(row.item.evaluation_file.id)" class="btn btn-danger btn-sm">
                        <span class="icon icon-trash"> Delete</span>
                    </b-button>
            </template>
        </b-table>
 
    </div>
</template>

<script>
const items = [];
var moment = require('moment');
export default {
  props: ['evaluation_files', 'user_role'],
  data() {
    return {
      moment: moment,
      items: this.evaluation_files,
      role: this.user_role,
      fields: [
        { key: "user.name", label: "Student" },
        { key: "preceptor_name", label: "Evaluator" },
        { key: "created_at", label: "Date Uploaded"},
        { key: "actions", label: "Action"}
      ],
      filter: null,
      sortBy: null,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(f => f.sortable).map(f => {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    deleteFile(id){
        Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
            if (result.isConfirmed) {
              axios.delete('/delete-evaluation-file/' + id)
              .then(response => this.items = response.data)
              .catch(function (error) {
                  // handle error
                  Swal.fire({
                  title: 'Oops',
                  text: "Something went wrong, please contact support.",
                  icon: 'warning'
                  })
                  console.log(error);
              });
            }});
    },
    downloadFile(user, file) {
        window.open('/file/' + user + '/' + file, '_blank');
    },
  },
};
</script>

<!-- table-complete-1.vue -->